/* eslint-disable @typescript-eslint/no-explicit-any */
import request from 'utils/request';

const analyticLostProfitService = {
  getList: (params: any) => request.get('/analytic/lost-profit', { params })
};

export default analyticLostProfitService;
